// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__8wQrm","root":"Alert_root__QbaGd","icon":"Alert_icon__3d9j_","error":"Alert_error__3ecRQ","warning":"Alert_warning__3eG07"};